<template>
  <div class="row">
    <div class="col-12 grid-margin stretch-card">
      <div class="card">
        <div class="card-body">
          <div
            class="card-title mb-4"
            v-if="form.usr_id != null && form.usr_id > 0"
          >
            {{ form.usr_user_name }}
          </div>
          <BForm @submit.prevent="onSubmit">
            <div class="row">
              <div class="form-group col-md-6">
                <label for="exampleSelectGender"
                  >User Role<span class="mandatory-sign">*</span></label
                >
                <BFormSelect
                  class="form-control form-select form-control-lg"
                  v-model="form.urm_id"
                  :options="ddlRole"
                  :state="is_valid_user_role"
                  aria-describedby="intpur_error_user_role"
                />
                <BFormInvalidFeedback id="intpur_error_user_role">
                  Select Role
                </BFormInvalidFeedback>
              </div>
              <div
                class="form-group col-md-6"
                v-if="this.objUser.usr_id == null || this.objUser.usr_id == 0"
              >
                <label for="exampleInputEmail3"
                  >Username <span class="mandatory-sign">*</span></label
                >
                <BFormInput
                  id="inline-form-input-name"
                  v-model="form.usr_user_name"
                  class="form-control form-control-lg"
                  placeholder="Username"
                  :state="is_valid_user_name"
                  aria-describedby="input_error_user_name"
                  maxlength="30"
                />
                <BFormInvalidFeedback id="input_error_user_name">
                  Enter User name
                </BFormInvalidFeedback>
              </div>
              <div class="form-group col-md-6">
                <label for="exampleInputPassword4"
                  >Email<span class="mandatory-sign">*</span></label
                >
                <BFormInput
                  id="inline-form-input-name"
                  v-model="form.usr_email"
                  class="form-control form-control-lg"
                  placeholder="Email"
                  :state="is_valid_user_email"
                  aria-describedby="input_error_user_email"
                  maxlength="200"
                />
                <BFormInvalidFeedback id="input_error_user_email">
                  {{ email_validation_msg }}
                </BFormInvalidFeedback>
              </div>
              <div
                class="form-group col-md-6"
                v-if="this.objUser.usr_id == null || this.objUser.usr_id == 0"
              >
                <label for="exampleInputPassword4"
                  >Password<span class="mandatory-sign">*</span></label
                >

                <BInputGroup>
                  <template #append>
                    <BInputGroupText
                      style="font-size: 1.2rem"
                      @click="showPass ? (showPass = false) : (showPass = true)"
                      ><i
                        :class="!showPass ? 'mdi mdi-eye-off' : 'mdi mdi-eye'"
                      ></i>
                    </BInputGroupText>
                  </template>
                  <BFormInput
                    id="inline-form-input-name"
                    v-model="form.usr_password"
                    :type="showPass ? 'text' : 'password'"
                    class="form-control form-control-lg"
                    placeholder="Password"
                    :state="is_valid_user_pass"
                    aria-describedby="input_error_user_pass"
                    title="Must contain at least one number and one uppercase and lowercase letter, and at least 8 or more characters"
                    minlength="8"
                    maxlength="100"
                  />
                </BInputGroup>
                <!-- maxlength="8" -->
                <BFormInvalidFeedback
                  id="input_error_user_pass"
                  style="display: block"
                  v-if="is_valid_user_pass != null && !is_valid_user_pass"
                >
                  Enter password
                </BFormInvalidFeedback>
                <!-- @change="onChangePass($event)" -->
                <!-- <BFormInput id="inline-form-input-name" v-model="form.usr_password"
                                    class="form-control form-control-lg" placeholder="Password"
                                    :state="is_valid_user_pass" aria-describedby="input_error_user_pass"
                                    title="Must contain at least one number and one uppercase and lowercase letter, and at least 8 or more characters" />
                                <BFormInvalidFeedback id="input_error_user_pass"> Enter Password
                                </BFormInvalidFeedback> -->
              </div>
              <div
                class="form-group col-md-6"
                v-if="this.objUser.usr_id == null || this.objUser.usr_id == 0"
              >
                <label for="exampleInputPassword4"
                  >Confirm Password<span class="mandatory-sign">*</span></label
                >
                <!-- <BFormInput id="inline-form-input-name" v-model="form.usr_confirm_pass"
                                    class="form-control form-control-lg" placeholder="Confirm Password"
                                    :state="is_valid_user_confirm_pass"
                                    aria-describedby="input_error_user_confirm_pass" />
                                <BFormInvalidFeedback id="input_error_user_confirm_pass"> {{ confirm_pass_val_msg }}
                                </BFormInvalidFeedback> -->

                <BInputGroup>
                  <template #append>
                    <BInputGroupText
                      style="font-size: 1.2rem"
                      @click="
                        showConfirmPass
                          ? (showConfirmPass = false)
                          : (showConfirmPass = true)
                      "
                      ><i
                        :class="
                          !showConfirmPass ? 'mdi mdi-eye-off' : 'mdi mdi-eye'
                        "
                      ></i>
                    </BInputGroupText>
                  </template>
                  <BFormInput
                    id="inline-form-input-name"
                    :type="showConfirmPass ? 'text' : 'password'"
                    v-model="form.usr_confirm_pass"
                    class="form-control form-control-lg"
                    placeholder="Confirm Password"
                    :state="is_valid_user_confirm_pass"
                    aria-describedby="input_error_user_pass"
                    title="Must contain at least one number and one uppercase and lowercase letter, and at least 8 or more characters"
                    minlength="8"
                    maxlength="100"
                  />
                </BInputGroup>
                <BFormInvalidFeedback
                  id="input_error_user_confirm_pass"
                  style="display: block"
                  v-if="
                    confirm_pass_val_msg != null &&
                    is_valid_user_confirm_pass != null &&
                    !is_valid_user_confirm_pass
                  "
                >
                  {{ confirm_pass_val_msg }}
                </BFormInvalidFeedback>
                <!-- @change="onChangePass($event)" -->
              </div>
              <div class="form-group col-md-6">
                <ul class="requirements">
                  <li
                    v-for="(requirement, key) in passwordRequirements"
                    :key="key"
                    :class="requirement.predicate ? 'is-success' : 'is-error'"
                  >
                    {{ requirement.name }}
                  </li>
                </ul>
              </div>
              <div class="mt-3">
                <BButton
                  class="btn btn-block btn-gradient-primary btn-lg font-weight-medium auth-form-btn"
                  type="submit"
                  >Submit
                </BButton>
                <BButton class="btn btn-light" @click="cancel">Cancel </BButton>
              </div>
            </div>
          </BForm>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import axios from "axios";
import { toast } from "vue3-toastify";
// import { useAuthStore } from "@/store/auth_store";
// const auth_store = useAuthStore()
// const user = auth_store.logged_in_user.user
import { useLoading } from "vue-loading-overlay";
import { email_regex } from "@/main";

const $loading = useLoading();

const is_valid_user_role = null;
const is_valid_user_name = null;
const is_valid_user_email = null;
const is_valid_user_pass = null;
const is_valid_user_confirm_pass = null;
const email_validation_msg = "Enter Email";
const confirm_pass_val_msg = "Enter Confirm Password";
// const email_regex = /^[A-Za-z0-9._%+-]+@maxcessintl\.(com|eu)$/;
const ddlRole = [];
const showPass = false;
const showConfirmPass = false;

export default {
  name: "manage-product-release",
  props: {
    objUser: {},
    action_mode: String,
  },
  mounted() {
    this.getRoles();
  },
  data() {
    return {
      form: {
        usr_id: this.objUser.usr_id,
        usr_user_name: this.objUser.usr_user_name,
        usr_email: this.objUser.usr_email,
        usr_password:
          this.objUser.usr_id != null && this.objUser.usr_id > 0
            ? null
            : this.objUser.usr_password,
        urm_id: this.objUser.urm_id,
        usr_created_on:
          this.objUser.usr_id != null && this.objUser.usr_id > 0
            ? null
            : this.objUser.usr_created_on,
        usr_created_by:
          this.objUser.usr_id != null && this.objUser.usr_id > 0
            ? null
            : this.objUser.usr_created_by,
        usr_modified_on: this.objUser.usr_id == null ? null : new Date(),
        usr_modified_by: this.objUser.usr_id == null ? null : 106, //user.usr_id, //loggedin user id
        usr_status: this.objUser.usr_status,
        usr_confirm_pass: this.objUser.usr_confirm_pass,
      },
      is_valid_user_role,
      is_valid_user_name,
      is_valid_user_email,
      is_valid_user_pass,
      is_valid_user_confirm_pass,
      ddlRole,
      email_validation_msg,
      confirm_pass_val_msg,
      showPass,
      showConfirmPass,
      $loading,
    };
  },
  methods: {
    async onSubmit() {
      if (this.validateFormInput()) {
        let loader = this.$loading.show();
        await axios
          .post("/manage_user", this.form)
          .then((res) => {
            loader.hide();
            this.cancel();
          })
          .catch((err) => {
            loader.hide();
            if (err.response.data != undefined && err.response.data != null) {
              toast(err.response.data.detail, {
                autoClose: 2000,
                theme: "colored",
                type: "error",
                position: "bottom-left",
                dangerouslyHTMLString: true,
              });
            }
          });
      }
    },
    cancel() {
      this.$emit("is_cance_clicked", true);
    },
    validateFormInput() {
      this.is_valid_user_role = this.form.urm_id == "-1" ? false : true;
      this.is_valid_user_name = this.form.usr_user_name == "" ? false : true;
      this.is_valid_user_email = this.form.usr_email == "" ? false : true;

      if (this.form.usr_email == "") {
        this.is_valid_user_email = false;
      } else if (!email_regex.test(this.form.usr_email)) {
        this.is_valid_user_email = false;
        this.email_validation_msg = "Enter valid Email";
      } else {
        this.is_valid_user_email = true;
      }

      if (this.objUser.usr_id == null || this.objUser.usr_id == 0) {
        this.is_valid_user_pass = this.form.usr_password == "" ? false : true;
        this.is_valid_user_confirm_pass =
          this.form.usr_confirm_pass == "" ? false : true;
        // this.is_user_accepted_tc =
        //   this.form.user_is_accepted_tc != "accepted" ? false : true;

        if (
          this.form.usr_confirm_pass != undefined &&
          this.form.usr_confirm_pass != null &&
          this.form.usr_confirm_pass.length > 0 &&
          this.form.usr_password != this.form.usr_confirm_pass
        ) {
          this.is_valid_user_confirm_pass = false;
          this.confirm_pass_val_msg =
            "Password and confirm Password are mismatch";
        }
      } else {
        this.is_valid_user_confirm_pass = true;
        this.is_valid_user_pass = true;
      }

      if (
        !this.is_valid_user_role ||
        !this.is_valid_user_name ||
        !this.is_valid_user_email ||
        !this.is_valid_user_pass ||
        !this.is_valid_user_confirm_pass
      )
        return false;
      else return true;
    },
    getRoles() {
      let loader = this.$loading.show();
      axios
        .get("/getRoles")
        .then((res) => {
          if (res.data != null && res.data.length > 0) {
            loader.hide();
            this.ddlRole = [];
            this.ddlRole.push({ value: -1, text: "Select Role" });
            res.data.forEach((element) => {
              if (element.url_role_code != "ADM")
                this.ddlRole.push({
                  value: element.url_id,
                  text: element.url_role_desc,
                });
            });
          }
        })
        .catch((err) => {
          loader.hide();
        });
    },
  },
};
</script>
